import { LoadingButton } from '@mui/lab';
import { Box, CircularProgress, IconButton, Link, styled, Typography } from '@mui/material';

export const StyledYellowButton = styled(LoadingButton)(() => ({
    height: '40px',
    background: '#FFAF50',
    borderRadius: '10px',
    padding: '15px',
    marginTop: '20px',
    fontWeight: 700,
    '&:hover': {
        background: '#FFAF50'
    }
}));

export const StyledGreenButton = styled(LoadingButton)(() => ({
    height: '35px',
    background: '#134C03',
    borderRadius: '4px',
    color: '#FFFFFF',
    padding: '15px',
    marginTop: '20px',
    fontWeight: 700,
    '&:hover': {
        boxShadow: 'none',
        background: '#134C03',
        color: '#FFFFFF'
    }
}));

export const StyledWhiteButton = styled(LoadingButton)(() => ({
    height: '35px',
    borderRadius: '4px',
    background: '#FFFFFF',
    padding: '15px',
    marginTop: '20px',
    border: '1px solid #134C031F',
    marginRight: '20px',
    '&:hover': {
        boxShadow: 'none',
        background: '#FFFFFF'
    }
}));

export const StyledRedButton = styled(LoadingButton)(() => ({
    height: '35px',
    background: '#DD1313',
    borderRadius: '4px',
    color: '#FFFFFF',
    padding: '15px',
    marginTop: '20px',
    fontWeight: 700,
    '&:hover': {
        boxShadow: 'none',
        background: '#DD1313',
        color: '#FFFFFF'
    }
}));

export const StyledRowBox = styled(Box)(() => ({
    display: 'flex'
}));

export const StyledColumnBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column'
}));

export const StyledDashboardHeading = styled(Typography)(() => ({
    marginTop: '20px',
    fontWeight: 500
}));

export const StyledModalTitle = styled(StyledRowBox)(() => ({
    padding: '20px',
    color: '#FFFFFF',
    backgroundColor: '#134C03',
    justifyContent: 'space-around'
}));

export const StyledModalButtons = styled(StyledRowBox)(() => ({
    float: 'right',
    marginRight: '20px',
    marginBottom: '20px'
}));

export const StyledModalDescription = styled(Typography)(() => ({
    fontWeight: 500,
    margin: '40px 60px'
}));

export const StyledLink = styled(Link)(() => ({
    color: '#134C03',
    textDecoration: 'underline',
    textDecorationColor: '#134C03'
}));

export const StyledModalClientTitles = styled(Typography)(() => ({
    textAlign: 'left',
    fontWeight: 700,
    display: 'flex'
}));

export const StyledModalClientSubtitles = styled(Typography)(() => ({
    textAlign: 'left',
    fontWeight: 500
}));

export const StyledSquareImage = styled('img')(() => ({
    height: '80px',
    width: '80px',
    borderRadius: '10px',
    marginRight: '20px',
    objectFit: 'cover'
}));

export const StyledCircleImage = styled('img')(() => ({
    height: '80px',
    width: '80px',
    borderRadius: '50%',
    marginRight: '20px',
    objectFit: 'cover'
}));

export const StyledMediumTypography = styled(Typography)(() => ({
    fontWeight: 600
}));

export const StyledNormalTypography = styled(Typography)(() => ({
    fontWeight: 500
}));

export const StyledTableButton = styled(StyledGreenButton)(() => ({
    color: '#134C03',
    background: '#FFFFFF',
    textTransform: 'none',
    textDecoration: 'underline',
    letterSpacing: 0,
    '&:hover': {
        textDecoration: 'underline'
    }
}));

export const StyledButtonTable = styled(StyledTableButton)(() => ({
    '&:hover': {
        color: '#134C03',
        background: '#FFFFFF'
    }
}));

export const StyledAddBasketTitle = styled(StyledNormalTypography)(() => ({
    marginTop: '10px'
}));

export const StyledImageBox = styled(Box)(() => ({
    height: '115px',
    width: '204px',
    margin: '8px 18px 40px 0px',
    border: '1px solid #394A35'
}));

export const StyledIconButton = styled(IconButton)(() => ({
    height: '114px',
    width: '204px',
    '&:hover': {
        backgroundColor: 'transparent'
    }
}));

export const StyledCameraIcon = styled('img')(() => ({
    height: '30px',
    width: '40px',
    objectFit: 'contain'
}));

export const StyledDeleteLink = styled(StyledButtonTable)(() => ({
    margin: '3px 0px 0px -14px',
    '&:hover': {
        backgroundColor: 'transparent'
    }
}));

export const StyledImage = styled('img')(() => ({
    height: '115px',
    width: '204px',
    objectFit: 'cover'
}));

export const StyledBox = styled(StyledColumnBox)(() => ({
    alignItems: 'left',
    marginBottom: '60px'
}));

export const StyledFarmTitle = styled(StyledMediumTypography)(() => ({
    marginTop: '40px',
    marginBottom: '20px',
    color: '#394A35'
}));

export const StyledBasketBox = styled(StyledBox)(() => ({
    marginTop: '40px',
    maxWidth: '745px',
    marginLeft: '10px'
}));

export const StyledLayout = styled(StyledColumnBox)(() => ({
    justifyContent: 'space-between',
    minHeight: '100vh'
}));

export const StyledAuthLayout = styled(StyledColumnBox)(() => ({
    justifyContent: 'space-between',
    minHeight: '100vh'
}));
